import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";
import { isValidInput } from "../utils/validations";
import { APPROVED_STATUS } from "../utils/enums";

interface FreelancerRejectionReasonModalProps {
  open: boolean;
  onClose: (id: string, status: number, reason: string) => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  setRejectionRsn: Dispatch<SetStateAction<string>>;
  rejectionRsn: string;
  selectedId: string;
}

export default function FreelancerRejectionReasonModal({
  open,
  onClose,
  setOpen,
  rejectionRsn,
  setRejectionRsn,
  selectedId,
}: FreelancerRejectionReasonModalProps) {
  return (
    <Modal
      className="modal rejectReason_modal"
      open={open}
      onClose={() => setOpen(false)}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Add Rejection Reason</h2>
            <div className="btn-close" onClick={() => setOpen(false)}>
              <CloseIcon />
            </div>
          </div>
          <form className="form" action="">
            <div className="control_group">
              <label>Add Reason</label>
              <TextField
                placeholder="Enter Reason"
                fullWidth
                hiddenLabel
                multiline
                maxRows={5}
                minRows={5}
                value={rejectionRsn}
                onChange={(val) => {
                  if (isValidInput(val.target.value)) {
                    setRejectionRsn(val.target.value);
                  }
                }}
              />
            </div>
            <div className="footer_btn_flex">
              <Button className="btn btn_grey" onClick={() => setOpen(false)}>
                Cancel
              </Button>
              <Button
                className="btn btn_primary"
                onClick={() => onClose(selectedId, APPROVED_STATUS.REJECTED, rejectionRsn)}
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
} 